import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CookiesKeys, URLs } from "../../Constants/Consts";
import { fetchApi } from "../../Helpers/Functions";
import { addProjects } from "../../store/Projects";
import { updateDownloadTriggered, updateHasDownloadedValue } from "../../store/Utilities";
import { RootState } from "../../store/store";
import Cookies from "js-cookie";

export default function storeProjects() {
    const dispatch = useDispatch()
    const [isloading, setIsloading] = useState(false)
    const [storedProjects, setStoredProjects] = useState([])
    const SelectedUser = useSelector(
        (state: RootState) => state.SelectedUser.SelectedUser
    );
    const { downloadTriggered: { projects: triggered } } = useSelector(
        (state: RootState) => state.Utilities
    );
    const calledOnceRef = useRef(false)
    const currentToken = Cookies.get(CookiesKeys.jwt)

    useEffect(() => {
        (async () => {
            if (navigator.onLine && SelectedUser.jwt && currentToken && (!calledOnceRef.current || triggered)) {
                calledOnceRef.current = true
                setIsloading(true)

                const projects = await fetchApi(URLs.getProjectsUrl()).then(res => res.json())
                dispatch(addProjects(projects))
                setStoredProjects(projects)
                setIsloading(false)
                dispatch(updateHasDownloadedValue({ key: "projects", value: true }))
                dispatch(updateDownloadTriggered({ key: "projects", value: false }))
                // chain downloading disciplines and access levels
                dispatch(updateDownloadTriggered({ key: "disciplines", value: true }))
                dispatch(updateDownloadTriggered({ key: "accessLevels", value: true }))
            }
        })()
    }, [SelectedUser.jwt, triggered])
    return { isloading, storedProjects }
}
